import { render, staticRenderFns } from "./UltralocalBatches.vue?vue&type=template&id=838ed562&scoped=true"
import script from "./UltralocalBatches.vue?vue&type=script&lang=js"
export * from "./UltralocalBatches.vue?vue&type=script&lang=js"
import style0 from "./UltralocalBatches.vue?vue&type=style&index=0&id=838ed562&prod&scoped=true&lang=css"
import style1 from "./UltralocalBatches.vue?vue&type=style&index=1&id=838ed562&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838ed562",
  null
  
)

export default component.exports